// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Exam_wrapper__19Qo0"};